import React, { Suspense } from "react";
import { RouterProvider, createBrowserRouter, Outlet } from "react-router-dom";
import { SearchProvider } from "./context/SearchContext";
import { ThemeProvider } from "./context/ThemeContext";
import Home from "./pages/Home";
import CheatSheetPage from "./pages/CheatSheetPage";
import SearchPage from "./pages/SearchPage";
import BackToTop from "./components/BackToTop";
import Footer from "./components/Footer";
import DonatePopup from "./components/DonatePopup";
import "./styles/App.css";

// Error boundary component
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("App Error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-page">
          <h1>Something went wrong</h1>
          <button onClick={() => window.location.reload()}>Reload Page</button>
        </div>
      );
    }

    return this.props.children;
  }
}

// Create router configuration
const router = createBrowserRouter(
  [
    {
      path: "/",
      element: (
        <div className="min-h-screen flex flex-col">
          <div className="flex-1">
            <Outlet />
          </div>
          <BackToTop />
          <Footer />
          <DonatePopup />
        </div>
      ),
      children: [
        {
          index: true,
          element: <Home />,
        },
        {
          path: "cheatsheet/:id",
          element: <CheatSheetPage />,
        },
        {
          path: "search",
          element: <SearchPage />,
        },
        {
          path: "*",
          element: <Home />,
        },
      ],
    },
  ],
  {
    basename: "/",
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  }
);

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <SearchProvider>
          <Suspense fallback={<div>Loading...</div>}>
            <RouterProvider router={router} />
          </Suspense>
        </SearchProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
